module.exports = __webpack_public_path__ + "img/resep-digital.83685574.png";